/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Forgot_SubtitleInputs */

const cs_auth_forgot_subtitle = /** @type {(inputs: Auth_Forgot_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zadejte e-mail. Pokud účet existuje, pošleme odkaz pro nastavení nového hesla.`)
};

const en_auth_forgot_subtitle = /** @type {(inputs: Auth_Forgot_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter your email and we will send a reset link if an account exists.`)
};

/**
* | output |
* | --- |
* | "Enter your email and we will send a reset link if an account exists." |
*
* @param {Auth_Forgot_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_forgot_subtitle = /** @type {((inputs?: Auth_Forgot_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Forgot_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_forgot_subtitle(inputs)
	return cs_auth_forgot_subtitle(inputs)
});